const dashboardAlertGetter = (state) => state.dashboardAlert;

export const dashboardAlertSelector = (state) => ({
  dashboardAlert: dashboardAlertGetter(state)
});
